<template>
  <div>
    <base-img
      :src="require('@/assets/mantap-berhijrah.png')"
      contain
      max-width="250"
      class="ml-n6"
    />

    <base-body>
      <b class="white--text">M</b>aslahah, <b class="white--text">A</b>ma<b
        class="white--text"
        >N</b
      >ah, <b class="white--text">Ta</b>'awuni,
      <b class="white--text">P</b>rogresif Profesional
      <br />
      <br />
      <p>
        PT Asuransi Takaful Umum Berizin dan Diawasi oleh Otoritas Jasa Keuangan
      </p>
    </base-body>
    <!-- <div id="google_translate_element"></div> -->
  </div>
</template>
<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "01 (800) 433 744<br>01 (800) 433 633"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "john@vuetifyjs.com<br>heather@vuetifyjs.com"
      }
    ]
  })
};
</script>
